import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./tip-input.module.css";

class TipInput extends Component {
  constructor(props) {
    super(props);
    const { initialTip = 0, initialTipType = "dollar" } = this.props;
    this.state = {
      tip: initialTip,
      tipType: initialTipType,
    };
  }

  componentDidMount() {
    const { tip, tipType } = this.state;
    const { onTipChange } = this.props;
    onTipChange(tip, tipType);
  }

  handleTipChange = (e) => {
    const newTip = e.target.value;
    this.setState({ tip: newTip }, () => {
      const { tipType } = this.state;
      const { onTipChange } = this.props;
      onTipChange(newTip, tipType);
    });
  };

  toggleTipType = () => {
    this.setState(
      (prevState) => ({
        tipType: prevState.tipType === "dollar" ? "percentage" : "dollar",
      }),
      () => {
        const { tip, tipType } = this.state;
        const { onTipChange } = this.props;
        onTipChange(tip, tipType);
      }
    );
  };

  render() {
    const { tip, tipType } = this.state;

    return (
      <div className={styles.container}>
        <button
          className={`${styles.toggleButton}`}
          onClick={this.toggleTipType}
        >
          {tipType === "dollar" ? "$" : "%"}
        </button>
        <input
          type="text"
          value={tip}
          onChange={this.handleTipChange}
          className={styles.inputField}
          placeholder="$0.00"
        />
      </div>
    );
  }
}

TipInput.propTypes = {
  onTipChange: PropTypes.func.isRequired,
  initialTip: PropTypes.number,
  initialTipType: PropTypes.string,
};

TipInput.defaultProps = {
  initialTip: 0,
  initialTipType: "dollar",
};

export default TipInput;